import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect, useMemo } from 'react';
import TabsContext from './TabsContext.js';
import { jsx } from 'react/jsx-runtime';
import useUniqueId from '../../hooks/useUniqueId.js';

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
    _ref$selectedIndex = _ref.selectedIndex,
    controlledSelectedIndex = _ref$selectedIndex === void 0 ? undefined : _ref$selectedIndex,
    _ref$defaultIndex = _ref.defaultIndex,
    defaultIndex = _ref$defaultIndex === void 0 ? 0 : _ref$defaultIndex;
  var _useState = useState(defaultIndex),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var _useState3 = useState(defaultIndex),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedIndex = _useState4[0],
    setSelectedIndex = _useState4[1];
  var baseId = useUniqueId();
  useEffect(function () {
    if (onChange && controlledSelectedIndex !== null) {
      setSelectedIndex(controlledSelectedIndex);
    }
  }, [controlledSelectedIndex, onChange]);
  var value = useMemo(function () {
    var handleTabChange = function handleTabChange(index) {
      if (onChange && controlledSelectedIndex) {
        onChange(index);
      } else {
        setSelectedIndex(index);
        if (onChange) {
          onChange(index);
        }
      }
    };
    return {
      baseId: baseId,
      activeIndex: activeIndex,
      setActiveIndex: setActiveIndex,
      selectedIndex: selectedIndex,
      setSelectedIndex: handleTabChange
    };
  }, [baseId, activeIndex, selectedIndex, onChange, controlledSelectedIndex]);
  return /*#__PURE__*/jsx(TabsContext.Provider, {
    value: value,
    children: children
  });
};
var Tabs$1 = Tabs;

export { Tabs$1 as default };
//# sourceMappingURL=Tabs.js.map
